// extracted by mini-css-extract-plugin
export default {"recipeImgLarge":"G3b52e9","recipeImgSmall":"Ga818ce","standard":"Gd52d27","large":"Gb79692","placeholder":"G44a089"};